<script>
  export let errors;
  export let fieldName;
</script>

{#if errors[fieldName]}
  <p class="text-red-500 text-xs -mb-2">
    {errors[fieldName]}
  </p>
{:else}
  <div class="mb-2" />
{/if}
